document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.startsWith('/apps/advanced-wishlist')) return;

  var WISHLIST_TITLE_TEXT = 'Favourites';
  var SHARE_WISHLIST_LABEL = 'Share favourites';
  var SHARE_MODAL_TITLE_TEXT = 'Share favourites';
  var SHARE_MODAL_SUBMIT_TEXT = 'Share favourites';
  var SHARE_MODAL_SENDER_LABEL = 'Your name';
  var SHARE_MODAL_RECIPIENT_LABEL = 'Recipient email';
  var SHARE_MODAL_SUBJECT_LABEL = 'Subject';
  var SHARE_MODAL_SECONDARY_TEXT = 'Check out these favourites:';
  var SHARE_MODAL_SUCCESS_TOAST = 'Favourites shared successfully';
  var SHARE_MODAL_ERROR_TOAST = 'Couldn\'t share favourites. Please try again.';
  var TITLE_READY_CLASS = 'nella-wishlist-title-ready';
  var TITLE_DISPLAY_ATTRIBUTE = 'data-nella-title-display';
  var wishlistObserver = null;
  var observedWishlistRoot = null;
  var wishlistSyncTimer = null;
  var shareModalCleanupTimers = [];
  var guestShareModalCleanupTimers = [];
  var wishlistMessagePatched = false;
  var pendingShareToastUntil = 0;
  var isMobiloudApp = document.documentElement.classList.contains('is-mobiloud-app');
  var appAwareWishlistLoginUrl = '/customer_authentication/login?return_to='
    + encodeURIComponent(window.location.pathname + window.location.search);

  function isLegacyWishlistLoginHref(href) {
    if (!href) return false;

    return /^\/account\/login(?:[/?#]|$)/i.test(href)
      || /^https?:\/\/(?:www\.)?nellacutlery\.ca\/account\/login(?:[/?#]|$)/i.test(href);
  }

  function getControlLabel(node) {
    if (!node) return '';

    var text = '';

    if (node.matches('input[type="button"], input[type="submit"]')) {
      text = node.value || '';
    } else {
      text = node.textContent || '';
    }

    return text.replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function updateControlText(node, text) {
    if (!node) return;

    if (node.matches('input[type="button"], input[type="submit"]')) {
      if ((node.value || '').trim() === text) return;
      node.value = text;
      return;
    }

    if ((node.textContent || '').replace(/\s+/g, ' ').trim() === text) return;

    Array.prototype.slice.call(node.childNodes).forEach(function (child) {
      if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
        node.removeChild(child);
      }
    });

    node.appendChild(document.createTextNode(text));
  }

  function setNodeTextPreserveChildren(node, text) {
    if (!node) return;

    if (!node.children.length) {
      if ((node.textContent || '').replace(/\s+/g, ' ').trim() !== text) {
        node.textContent = text;
      }
      return;
    }

    Array.prototype.slice.call(node.childNodes).forEach(function (child) {
      if (child.nodeType === Node.TEXT_NODE) {
        node.removeChild(child);
      }
    });

    var firstChild = node.firstChild;
    var newText = text + ' ';

    if (firstChild && firstChild.nodeType === Node.TEXT_NODE && firstChild.textContent === newText) {
      return;
    }

    node.insertBefore(document.createTextNode(newText), firstChild || null);
  }

  function buildShareSubject(senderName) {
    return (senderName || 'Someone') + ' shared favourites';
  }

  function buildShareMessage(shareUrl) {
    return 'Hey there! Check out these favourites:\n\n' + (shareUrl || '');
  }

  function normalizeMultilineText(text) {
    return (text || '').replace(/\r\n/g, '\n').trim();
  }

  function getNormalizedShareToastMessage(message) {
    if (typeof message !== 'string') return message;

    var text = message.replace(/\s+/g, ' ').trim();
    var upper = text.toUpperCase();
    var looksLikeShareToast = upper.includes('SHARE') || upper.includes('WISHLIST') || upper.includes(' LIST ');
    var looksSuccessful = upper.includes('SUCCESS') || upper.includes('SUCCESSFULLY') || upper.includes('SHARED');
    var looksFailed = upper.includes('ERROR')
      || upper.includes('FAILED')
      || upper.includes('FAIL')
      || upper.includes('WRONG')
      || upper.includes('TRY AGAIN')
      || upper.includes('COULDN');

    if (looksLikeShareToast && looksSuccessful && !looksFailed) {
      return SHARE_MODAL_SUCCESS_TOAST;
    }

    if (
      looksLikeShareToast && looksFailed
      || pendingShareToastUntil > Date.now() && /something went wrong|please try again|failed|error/i.test(text)
    ) {
      return SHARE_MODAL_ERROR_TOAST;
    }

    return message
      .replace(/Share List Via Email/gi, SHARE_MODAL_TITLE_TEXT)
      .replace(/Share my wishlist/gi, SHARE_WISHLIST_LABEL)
      .replace(/Check out My Wishlist/gi, SHARE_MODAL_SECONDARY_TEXT)
      .replace(/shared their wishlist/gi, 'shared favourites')
      .replace(/wishlist/gi, 'favourites')
      .replace(/\blist\b/gi, 'favourites');
  }

  function patchWishlistMessageUpdate() {
    if (wishlistMessagePatched || !window.HulkappsWishlistPage || typeof window.HulkappsWishlistPage._messageUpdate !== 'function') {
      return;
    }

    var originalMessageUpdate = window.HulkappsWishlistPage._messageUpdate;

    window.HulkappsWishlistPage._messageUpdate = function (message, productTitle, productImage, allowHtml) {
      return originalMessageUpdate.call(
        this,
        getNormalizedShareToastMessage(message),
        productTitle,
        productImage,
        allowHtml
      );
    };

    wishlistMessagePatched = true;
  }

  function normalizeWishlistNotifications() {
    var details = document.querySelector('.wishlistError .notification_details');
    if (!details) return;

    var nextText = getNormalizedShareToastMessage(details.textContent || '');
    if ((details.textContent || '').replace(/\s+/g, ' ').trim() !== nextText.replace(/\s+/g, ' ').trim()) {
      details.textContent = nextText;
    }
  }

  function getSignedInShareFields(form) {
    var result = {
      senderInput: null,
      recipientInput: null,
      subjectInput: null,
      messageInput: null,
      submitButton: null
    };

    Array.prototype.slice.call(form.querySelectorAll('.floating-label')).forEach(function (wrapper) {
      var label = wrapper.querySelector('label');
      var control = wrapper.querySelector('input:not([type="hidden"]), textarea, button, input[type="submit"]');
      var labelText = label ? (label.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase() : '';
      var nameAttr = control ? ((control.getAttribute('name') || '') + ' ' + (control.getAttribute('id') || '')).toUpperCase() : '';

      if (!control) return;

      if (control.matches('[data-HulkSendEmailButton], button, input[type="submit"]')) {
        result.submitButton = control;
        return;
      }

      if (control.matches('textarea')) {
        result.messageInput = control;
        return;
      }

      if (control.type === 'email' || labelText.includes('EMAIL') || nameAttr.includes('EMAIL')) {
        result.recipientInput = control;
        return;
      }

      if (labelText.includes('SUBJECT') || nameAttr.includes('SUBJECT')) {
        result.subjectInput = control;
        return;
      }

      if (!result.senderInput) {
        result.senderInput = control;
      }
    });

    return result;
  }

  function setManagedShareFieldValue(field, nextValue, stalePatterns) {
    if (!field) return;

    var currentValue = normalizeMultilineText(field.value || '');
    var isManaged = field.getAttribute('data-nella-share-managed') === 'true';
    var matchesStaleValue = stalePatterns.some(function (pattern) {
      return pattern.test(currentValue);
    });

    if (!currentValue || isManaged || matchesStaleValue) {
      if (currentValue !== normalizeMultilineText(nextValue)) {
        field.value = nextValue;
      }
      field.setAttribute('data-nella-share-managed', 'true');
    }
  }

  function bindShareFieldGuard(field, valueBuilder) {
    if (!field || field.hasAttribute('data-nella-share-guard-bound')) return;

    field.setAttribute('data-nella-share-guard-bound', 'true');
    field.addEventListener('input', function () {
      var expected = normalizeMultilineText(valueBuilder());
      var current = normalizeMultilineText(field.value || '');
      field.setAttribute('data-nella-share-managed', current === expected ? 'true' : 'false');
    });
  }

  function normalizeSignedInShareModalCopy(popup, form, title, helperText) {
    var fields = getSignedInShareFields(form);
    var senderInput = fields.senderInput;
    var recipientInput = fields.recipientInput;
    var subjectInput = fields.subjectInput;
    var messageInput = fields.messageInput;
    var submitButton = fields.submitButton;
    var shareUrlInput = popup.querySelector('[data-shareURL]');
    var shareUrl = shareUrlInput ? (shareUrlInput.value || '').trim() : '';
    var senderName = senderInput ? (senderInput.value || '').trim() : '';

    setNodeTextPreserveChildren(title, SHARE_MODAL_TITLE_TEXT);

    Array.prototype.slice.call(form.querySelectorAll('.floating-label')).forEach(function (wrapper) {
      var label = wrapper.querySelector('label');
      var control = wrapper.querySelector('input:not([type="hidden"]), textarea, button, input[type="submit"]');

      if (!label || !control) return;

      if (control === senderInput) {
        setNodeTextPreserveChildren(label, SHARE_MODAL_SENDER_LABEL);
      } else if (control === recipientInput) {
        setNodeTextPreserveChildren(label, SHARE_MODAL_RECIPIENT_LABEL);
      } else if (control === subjectInput) {
        setNodeTextPreserveChildren(label, SHARE_MODAL_SUBJECT_LABEL);
      }
    });

    if (submitButton) {
      updateControlText(submitButton, SHARE_MODAL_SUBMIT_TEXT);
    }

    if (helperText) {
      setNodeTextPreserveChildren(helperText, SHARE_MODAL_SECONDARY_TEXT);
    }

    if (subjectInput) {
      setManagedShareFieldValue(subjectInput, buildShareSubject(senderName), [
        /shared their wishlist/i,
        /shared favourites/i,
        /share my wishlist/i,
        /check out my wishlist/i
      ]);
      bindShareFieldGuard(subjectInput, function () {
        return buildShareSubject(senderInput ? (senderInput.value || '').trim() : '');
      });
    }

    if (messageInput) {
      setManagedShareFieldValue(messageInput, buildShareMessage(shareUrl), [
        /check out my wishlist/i,
        /share my wishlist/i,
        /wishlist/i,
        /check out these favourites:/i
      ]);
      bindShareFieldGuard(messageInput, function () {
        return buildShareMessage(shareUrlInput ? (shareUrlInput.value || '').trim() : '');
      });
    }

    if (senderInput && !senderInput.hasAttribute('data-nella-share-source-bound')) {
      senderInput.setAttribute('data-nella-share-source-bound', 'true');
      senderInput.addEventListener('input', function () {
        if (subjectInput && subjectInput.getAttribute('data-nella-share-managed') === 'true') {
          subjectInput.value = buildShareSubject((senderInput.value || '').trim());
        }
      });
    }
  }

  function normalizeWishlistCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var titles = [];

    if (root && root.matches && root.matches('[data-mywishlisttitle], [data-wishlisttitle]')) {
      titles.push(root);
    }

    titles = titles.concat(
      Array.prototype.slice.call(scope.querySelectorAll('[data-mywishlisttitle], [data-wishlisttitle]'))
    );

    titles.forEach(function (title) {
      var currentText = (title.textContent || '').replace(/\s+/g, ' ').trim();

      if (title.getAttribute(TITLE_DISPLAY_ATTRIBUTE) !== WISHLIST_TITLE_TEXT) {
        title.setAttribute(TITLE_DISPLAY_ATTRIBUTE, WISHLIST_TITLE_TEXT);
      }

      if (currentText !== WISHLIST_TITLE_TEXT) {
        title.textContent = WISHLIST_TITLE_TEXT;
      }

      if (!title.classList.contains(TITLE_READY_CLASS)) {
        title.classList.add(TITLE_READY_CLASS);
      }
    });
  }

  function normalizeWishlistAuthLinks(root) {
    if (!isMobiloudApp) return;

    var scope = root && root.querySelectorAll ? root : document;
    var links = [];

    if (root && root.matches && root.matches('a[href]')) {
      links.push(root);
    }

    links = links.concat(Array.prototype.slice.call(scope.querySelectorAll('a[href]')));

    links.forEach(function (link) {
      var href = (link.getAttribute('href') || '').trim();
      if (!isLegacyWishlistLoginHref(href)) return;

      if (href !== appAwareWishlistLoginUrl) {
        link.setAttribute('href', appAwareWishlistLoginUrl);
      }
    });
  }

  function getWishlistAppRoot() {
    return document.querySelector('.hulk__wishlist-wrap')
      || document.querySelector('[data-wishlistcontainer]')
      || document.querySelector('#MainContent');
  }

  function runWishlistOverrides(root) {
    var scope = root || getWishlistAppRoot() || document;
    patchWishlistMessageUpdate();
    normalizeWishlistAuthLinks(scope);
    normalizeWishlistCopy(scope);
    normalizeWishlistTopRow(scope);
    normalizeLoggedInTopActions(scope);
    cleanShareControls(scope);
    decorateWishlistEmptyState(scope);
    decorateSignedInShareModal(scope);
    decorateGuestShareModal(scope);
    decorateDeleteModals(scope);
    bindQtyControls(scope);
    normalizeWishlistNotifications();
    scheduleWishlistPriceRefresh();
  }

  function scheduleWishlistOverrideSync(root, delay) {
    var scope = root || getWishlistAppRoot() || document;
    var wait = typeof delay === 'number' ? delay : 40;

    if (wishlistSyncTimer) {
      clearTimeout(wishlistSyncTimer);
    }

    wishlistSyncTimer = setTimeout(function () {
      runWishlistOverrides(scope);
      ensureWishlistObserver();
    }, wait);
  }

  function ensureWishlistObserver() {
    var nextRoot = getWishlistAppRoot();

    if (!nextRoot || nextRoot === observedWishlistRoot) return;

    if (wishlistObserver) {
      wishlistObserver.disconnect();
    }

    observedWishlistRoot = nextRoot;
    wishlistObserver = new MutationObserver(function (mutations) {
      function isRelevantWishlistAttributeMutation(mutation) {
        if (!mutation || mutation.type !== 'attributes') return false;

        var target = mutation.target;
        if (!target || !target.matches) return false;

        if (target.matches('[data-forMultipleDisabled], [data-formultipledisabled], .share_sbcrb, [data-HulkShareWishList], [data-hulksharewishlist], .fancy_title')) {
          return true;
        }

        return !!target.closest(
          '.hulk__wishlist-wrap .fancy_title, .hulk__wishlist-wrap .share_sbcrb, .hulk__wishlist-wrap [data-HulkShareWishList], .hulk__wishlist-wrap [data-hulksharewishlist]'
        );
      }

      var shouldSync = mutations.some(function (mutation) {
        if (mutation.type === 'characterData') return true;
        if (mutation.type === 'childList') {
          return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
        }
        if (mutation.type === 'attributes') {
          return isRelevantWishlistAttributeMutation(mutation);
        }

        return false;
      });

      if (shouldSync) {
        scheduleWishlistOverrideSync(observedWishlistRoot, 40);
        // Pass 251/251B: detect .wishlist__product added OR removed (delete
        // re-render, pagination, or any Hulk list rebuild) and schedule a
        // reclean so newly-mounted cards get prices resolved. Our own mutations
        // (skeleton, price slot, hulk-price removal) are child elements INSIDE
        // .wishlist__product, never .wishlist__product itself — so this check
        // never fires on our own DOM writes, preventing an observer loop.
        if (shouldRefreshB2BPrices) {
          var hasWishlistCardChange = mutations.some(function (mutation) {
            if (mutation.type !== 'childList') return false;
            var changed = Array.prototype.slice.call(mutation.addedNodes)
              .concat(Array.prototype.slice.call(mutation.removedNodes));
            return changed.some(function (node) {
              return node.nodeType === 1
                && ((node.matches && node.matches('.wishlist__product'))
                    || (node.querySelectorAll && node.querySelectorAll('.wishlist__product').length > 0));
            });
          });
          if (hasWishlistCardChange) {
            schedulePostDeletePriceReclean();
          }
        }
      }
    });

    wishlistObserver.observe(observedWishlistRoot, {
      attributes: true,
      attributeFilter: ['style', 'class', 'data-uniqid', 'data-uniqId'],
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function cleanShareControls(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var controls = [];
    var shareWrappers = [];

    if (root && root.matches && root.matches('.share_sbcrb.enable-share_sbcrb[data-formultipledisabled]')) {
      shareWrappers.push(root);
    }

    shareWrappers = shareWrappers.concat(
      Array.prototype.slice.call(scope.querySelectorAll('.share_sbcrb.enable-share_sbcrb[data-formultipledisabled]'))
    );

    shareWrappers.forEach(function (wrapper) {
      wrapper.classList.add('nella-wishlist-share-control-wrapper');

      if (wrapper.hasAttribute('tabindex')) {
        wrapper.removeAttribute('tabindex');
      }
    });

    if (root && root.matches && root.matches('button, a, input[type="button"], input[type="submit"]')) {
      controls.push(root);
    }

    controls = controls.concat(
      Array.prototype.slice.call(scope.querySelectorAll('button, a, input[type="button"], input[type="submit"]'))
    );

    controls.forEach(function (control) {
      var label = getControlLabel(control);
      var isWishlistShareControl = control.matches('[data-hulksharewishlist], [data-hulkguestsharewishlist]');

      if (!isWishlistShareControl && label !== 'SHARE WISHLIST' && label !== 'SHARE FAVOURITES') return;

      control.classList.add('nella-wishlist-share-control');

      if (control.matches('[data-hulksharewishlist]')) {
        var shareWrapper = control.closest('.share_sbcrb.enable-share_sbcrb[data-formultipledisabled]');
        if (shareWrapper) {
          shareWrapper.classList.add('nella-wishlist-share-control-wrapper');

          if (shareWrapper.hasAttribute('tabindex')) {
            shareWrapper.removeAttribute('tabindex');
          }
        }
      }

      control.querySelectorAll('img, svg, i, [class*="icon"], [class*="Icon"]').forEach(function (icon) {
        icon.classList.add('nella-wishlist-share-control__icon');
      });

      updateControlText(control, SHARE_WISHLIST_LABEL);
    });
  }

  function normalizeWishlistTopRow(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var rows = [];

    if (root && root.matches && root.matches('.fancy_title')) {
      rows.push(root);
    }

    rows = rows.concat(
      Array.prototype.slice.call(scope.querySelectorAll('.hulk__wishlist-wrap .fancy_title'))
    );

    var isSignedIn = !!(window.hulkappsWishlist && window.hulkappsWishlist.customerID);

    rows.forEach(function (row) {
      row.classList.add('nella-wishlist-top-row');

      var title = row.querySelector('[data-mywishlisttitle], [data-wishlisttitle]');
      if (title) {
        title.classList.add('nella-wishlist-top-title');
      }

      if (!isSignedIn) {
        var guestTrigger = row.querySelector('[data-HulkGuestShareWishList], [data-hulkguestsharewishlist]');
        if (guestTrigger) {
          guestTrigger.classList.add('nella-wishlist-share-trigger');
        }
      }
    });
  }

  function getOrCreateSignedInTopShareTrigger(slot) {
    if (!slot) return null;

    var trigger = slot.querySelector('[data-nella-signed-in-share-trigger]');

    if (!trigger) {
      trigger = document.createElement('a');
      trigger.href = '#';
      trigger.setAttribute('data-nella-signed-in-share-trigger', 'true');
      slot.appendChild(trigger);
    }

    trigger.classList.add('nella-wishlist-share-control', 'nella-wishlist-share-trigger');
    trigger.removeAttribute('aria-hidden');
    updateControlText(trigger, SHARE_WISHLIST_LABEL);

    return trigger;
  }

  function normalizeLoggedInTopActions(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var actionRows = [];
    var isSignedInWishlist = !!(window.hulkappsWishlist && window.hulkappsWishlist.customerID);

    if (!isSignedInWishlist) return;

    if (root && root.matches && root.matches('.fancy_title')) {
      actionRows.push(root);
    }

    actionRows = actionRows.concat(
      Array.prototype.slice.call(scope.querySelectorAll('.hulk__wishlist-wrap .fancy_title'))
    );

    actionRows.forEach(function (row) {
      var primaryShare = row.querySelector('.share_sbcrb[data-formultipledisabled], .share_sbcrb[data-forMultipleDisabled]');
      var actionContainer = Array.prototype.slice.call(row.children).find(function (child) {
        return child.matches
          && child.matches('div')
          && child.querySelector('p');
      }) || null;
      var actionSlots = actionContainer
        ? Array.prototype.slice.call(actionContainer.children).filter(function (child) {
            return child.matches && child.matches('p');
          })
        : [];
      var leftShareSlot = actionSlots[0] || null;
      var rightShareSlot = actionSlots.find(function (slot) {
        return slot.querySelector('[data-HulkGuestShareWishList], [data-hulkguestsharewishlist]');
      }) || null;

      if (!primaryShare) {
        row.classList.remove('nella-wishlist-top-actions-ready', 'nella-wishlist-top-row--signed-in');
        row.querySelectorAll('[data-nella-signed-in-share-trigger]').forEach(function (trigger) {
          if (trigger.parentElement) {
            trigger.parentElement.removeChild(trigger);
          }
        });
        return;
      }

      if (actionContainer && !rightShareSlot) {
        rightShareSlot = actionSlots[actionSlots.length - 1] || document.createElement('p');

        if (!rightShareSlot.parentElement) {
          actionContainer.appendChild(rightShareSlot);
        }
      }

      row.classList.add('nella-wishlist-top-row', 'nella-wishlist-top-row--signed-in');
      primaryShare.classList.add('nella-wishlist-share-control-wrapper', 'nella-wishlist-top-share--primary', 'nella-wishlist-share-source--hidden');
      primaryShare.classList.remove('nella-wishlist-share-ready', 'nella-wishlist-share-staged');

      var title = row.querySelector('[data-mywishlisttitle], [data-wishlisttitle]');
      var shareLink = primaryShare.querySelector('[data-HulkShareWishList], [data-hulksharewishlist]');
      var shareNodes = Array.prototype.slice.call(
        row.querySelectorAll(
          '.share_sbcrb, [data-HulkGuestShareWishList], [data-hulkguestsharewishlist], [data-HulkShareWishList], [data-hulksharewishlist]'
        )
      );
      var stableTrigger = null;

      if (title) {
        title.classList.add('nella-wishlist-top-title');
      }

      if (primaryShare.hasAttribute('tabindex')) {
        primaryShare.removeAttribute('tabindex');
      }

      if (shareLink) {
        shareLink.removeAttribute('tabindex');
        shareLink.setAttribute('aria-hidden', 'true');
      }

      row.querySelectorAll('[data-nella-signed-in-share-trigger]').forEach(function (trigger) {
        if (rightShareSlot) {
          if (trigger.parentElement !== rightShareSlot) {
            trigger.parentElement && trigger.parentElement.removeChild(trigger);
          }
        } else if (trigger.parentElement !== row) {
          trigger.parentElement && trigger.parentElement.removeChild(trigger);
        }
      });

      row.querySelectorAll('[data-MyAccount], [data-myaccount], [data-LoginBtn], [data-loginbtn], [data-HulkLoginMsg]').forEach(function (link) {
        link.classList.add('nella-wishlist-top-action--hidden');
        link.setAttribute('aria-hidden', 'true');
      });

      shareNodes.forEach(function (node) {
        if (node === primaryShare || primaryShare.contains(node)) return;

        node.classList.add('nella-wishlist-top-action--hidden');
        node.setAttribute('aria-hidden', 'true');

        if (node.hasAttribute && node.hasAttribute('tabindex')) {
          node.removeAttribute('tabindex');
        }
      });

      if (rightShareSlot) {
        if (primaryShare.parentElement !== rightShareSlot) {
          rightShareSlot.insertBefore(primaryShare, rightShareSlot.firstChild || null);
        }
        stableTrigger = getOrCreateSignedInTopShareTrigger(rightShareSlot);
        if (stableTrigger && rightShareSlot.lastElementChild !== stableTrigger) {
          rightShareSlot.appendChild(stableTrigger);
        }
      } else {
        if (primaryShare.parentElement !== row) {
          row.appendChild(primaryShare);
        }
        stableTrigger = getOrCreateSignedInTopShareTrigger(row);
        if (stableTrigger && row.lastElementChild !== stableTrigger) {
          row.appendChild(stableTrigger);
        }
      }

      actionSlots.forEach(function (slot) {
        var hasVisibleChild = Array.prototype.slice.call(slot.children).some(function (child) {
          return !child.classList.contains('nella-wishlist-top-action--hidden');
        });

        if (!hasVisibleChild && !(slot.textContent || '').trim()) {
          slot.classList.add('nella-wishlist-top-action--hidden');
          slot.setAttribute('aria-hidden', 'true');
        } else {
          slot.classList.remove('nella-wishlist-top-action--hidden');
          slot.removeAttribute('aria-hidden');
        }
      });

      if (actionContainer) {
        actionContainer.classList.remove('nella-wishlist-top-action--hidden');
        actionContainer.removeAttribute('aria-hidden');
      }

      if (leftShareSlot && leftShareSlot !== rightShareSlot) {
        var leftSlotHasVisibleChild = Array.prototype.slice.call(leftShareSlot.children).some(function (child) {
          return !child.classList.contains('nella-wishlist-top-action--hidden');
        });

        if (!leftSlotHasVisibleChild) {
          leftShareSlot.classList.add('nella-wishlist-top-action--hidden');
          leftShareSlot.setAttribute('aria-hidden', 'true');
        }
      }

      if (stableTrigger) {
        stableTrigger.removeAttribute('aria-hidden');
      }

      row.classList.add('nella-wishlist-top-actions-ready');
    });
  }

  function decorateWishlistEmptyState(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll('[data-hulkemptywishlist] .wishlist-btn.hulkBtnStyle.hulk-btn-styled');

    links.forEach(function (link) {
      link.setAttribute('href', '/');
    });
  }

  function decorateSignedInShareModal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var popups = scope.querySelectorAll('[data-HulkappsShare]');

    popups.forEach(function (popup) {
      var body = popup.querySelector('.wishlist-modal__body');
      var form = popup.querySelector('[data-HulkEmailForm]');
      var title = popup.querySelector('[data-emailPopupTitle]');
      var headerRow = title ? title.parentElement : null;
      var closeButtons = Array.prototype.slice.call(popup.querySelectorAll('.close-popup'));
      var closeButton = closeButtons[0];
      var divider = body ? body.querySelector('hr') : null;

      if (!body || !form || !title || !headerRow || !closeButton) return;

      // One-time structural setup: header row class, close button placement, submit row
      if (!popup.hasAttribute('data-nella-share-modal-ready')) {
        popup.setAttribute('data-nella-share-modal-ready', 'true');

        headerRow.classList.add('nella-wishlist-share-header-row');

        if (closeButton.parentElement !== headerRow) {
          headerRow.appendChild(closeButton);
        }

        var submitButton = popup.querySelector('[data-HulkSendEmailButton]');
        if (submitButton && submitButton.closest('.floating-label')) {
          submitButton.closest('.floating-label').classList.add('nella-wishlist-share-submit-row');
        }
      }

      // Search the whole popup — Hulk may place the secondary header inside
      // .wishlist-modal__body or as a sibling of it; both cases are covered here
      headerRow.classList.add('nella-wishlist-share-header-row');

      if (closeButton.parentElement !== headerRow) {
        headerRow.appendChild(closeButton);
      }

      closeButton.removeAttribute('aria-hidden');

      closeButtons.slice(1).forEach(function (button) {
        button.setAttribute('aria-hidden', 'true');
        if (button.parentElement) {
          button.parentElement.removeChild(button);
        }
      });

      var allHeaders = Array.prototype.slice.call(popup.querySelectorAll('.wishlist-modal__header'));
      var secondaryHeaders = allHeaders.filter(function (header) {
        return header !== headerRow;
      });

      if (secondaryHeaders.length) {
        // Social content may be children of secondaryHeader or body-level siblings
        var socialList = body.querySelector('.social-list-icon');
        var copyForm = body.querySelector('form.input-group.search-bar');
        var helperText = (function () {
          var candidates = Array.prototype.slice.call(body.querySelectorAll('p'));
          return candidates.find(function (node) {
            return (!form || !form.contains(node))
              && !secondaryHeaders.some(function (header) { return header.contains(node); });
          }) || null;
        }());

        // Ensure secondary content wrapper exists in body
        var secondary = body.querySelector('.nella-wishlist-share-secondary');
        if (!secondary) {
          secondary = document.createElement('div');
          secondary.className = 'nella-wishlist-share-secondary';
          if (divider && divider.nextSibling) {
            body.insertBefore(secondary, divider.nextSibling);
          } else {
            body.appendChild(secondary);
          }
        }

        // Move social content into wrapper before removing the secondary header
        [socialList, helperText, copyForm].forEach(function (node) {
          if (node && !secondary.contains(node)) {
            secondary.appendChild(node);
          }
        });

        secondaryHeaders.forEach(function (header) {
          Array.prototype.slice.call(header.querySelectorAll('.close-popup')).forEach(function (button) {
            button.setAttribute('aria-hidden', 'true');
            if (button.parentElement) {
              button.parentElement.removeChild(button);
            }
          });

          header.classList.remove('wishlist-modal__header');
          header.classList.add('nella-wishlist-modal-subsection-header');

          if (!secondary.contains(header)) {
            secondary.appendChild(header);
          }
        });
      }

      // Find helper text in secondary wrapper for copy normalization
      var secondaryWrapper = body.querySelector('.nella-wishlist-share-secondary');
      var helperTextForCopy = secondaryWrapper
        ? Array.prototype.slice.call(secondaryWrapper.querySelectorAll('p')).find(function (node) {
            return !form || !form.contains(node);
          }) || null
        : null;

      normalizeSignedInShareModalCopy(popup, form, title, helperTextForCopy);
    });
  }

  function scheduleSignedInShareModalCleanup() {
    shareModalCleanupTimers.forEach(function (timerId) {
      clearTimeout(timerId);
    });
    shareModalCleanupTimers = [];

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        decorateSignedInShareModal(document);
      });
    } else {
      decorateSignedInShareModal(document);
    }

    [100, 250].forEach(function (delay) {
      var timerId = setTimeout(function () {
        decorateSignedInShareModal(document);
      }, delay);

      shareModalCleanupTimers.push(timerId);
    });
  }

  function scheduleGuestShareModalCleanup() {
    guestShareModalCleanupTimers.forEach(function (timerId) {
      clearTimeout(timerId);
    });
    guestShareModalCleanupTimers = [];

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        decorateGuestShareModal(document);
      });
    } else {
      decorateGuestShareModal(document);
    }

    [100, 250].forEach(function (delay) {
      var timerId = setTimeout(function () {
        decorateGuestShareModal(document);
      }, delay);

      guestShareModalCleanupTimers.push(timerId);
    });
  }

  function decorateGuestShareModal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var popups = scope.querySelectorAll('[data-HulkappsGuestShare]');

    popups.forEach(function (popup) {
      var header = popup.querySelector('.wishlist-modal__header');
      var closeButtons = Array.prototype.slice.call(popup.querySelectorAll('.close-popup'));
      var closeBtn = closeButtons[0];

      if (!header || !closeBtn) return;

      if (!popup.hasAttribute('data-nella-guest-modal-ready')) {
        popup.setAttribute('data-nella-guest-modal-ready', 'true');
      }

      header.classList.add('nella-wishlist-modal-header-row');

      if (closeBtn.parentElement !== header) {
        header.appendChild(closeBtn);
      }

      closeBtn.removeAttribute('aria-hidden');

      closeButtons.slice(1).forEach(function (button) {
        button.setAttribute('aria-hidden', 'true');
        if (button.parentElement) {
          button.parentElement.removeChild(button);
        }
      });

      var allHeaders = Array.prototype.slice.call(popup.querySelectorAll('.wishlist-modal__header'));
      var secondaryHeaders = allHeaders.filter(function (row) {
        return row !== header;
      });

      secondaryHeaders.forEach(function (row) {
        Array.prototype.slice.call(row.querySelectorAll('.close-popup')).forEach(function (button) {
          button.setAttribute('aria-hidden', 'true');
          if (button.parentElement) {
            button.parentElement.removeChild(button);
          }
        });

        row.classList.remove('wishlist-modal__header');
        row.classList.add('nella-wishlist-modal-subsection-header');
      });
    });
  }

  function decorateDeleteModals(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var popups = scope.querySelectorAll('.wishlist-popup.wishlist-delete-popup');

    popups.forEach(function (popup) {
      if (popup.hasAttribute('data-nella-delete-modal-ready')) return;

      var header = popup.querySelector('.wishlist-modal__header');
      var closeButtons = popup.querySelectorAll('.close-popup');
      var closeBtn = closeButtons[0];

      if (!header || !closeBtn) return;

      popup.setAttribute('data-nella-delete-modal-ready', 'true');
      header.classList.add('nella-wishlist-modal-header-row');

      closeButtons.forEach(function (button, index) {
        if (index === 0) return;
        button.setAttribute('aria-hidden', 'true');
      });

      if (closeBtn.parentElement !== header) {
        header.appendChild(closeBtn);
      }
    });
  }

  function fixQtyMinusState(wrapper) {
    var input = wrapper.querySelector('input[data-hulkproductqty]');
    var minus = wrapper.querySelector('[data-hulkqtyminus]');
    if (!input || !minus) return;
    var val = parseInt(input.value, 10);
    if (val > 1) {
      minus.removeAttribute('disabled');
    } else {
      minus.setAttribute('disabled', '');
    }
  }

  function bindQtyControls(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.hlk_wl_productQty-inputs').forEach(function (wrapper) {
      if (wrapper.hasAttribute('data-nella-qty-bound')) return;
      wrapper.setAttribute('data-nella-qty-bound', 'true');

      wrapper.addEventListener('click', function (event) {
        var btn = event.target && event.target.closest
          ? event.target.closest('[data-hulkqtyplus], [data-hulkqtyminus]')
          : null;
        if (!btn) return;
        setTimeout(function () { fixQtyMinusState(wrapper); }, 0);
      });
    });
  }

  // ── Wishlist price refresh via Section Rendering API ─────────────────────
  // Hulk renders prices from its own stored data. To get the exact same price
  // output as the PDP — including B2B negotiated price, retail_price metafield
  // compare-at, email-for-price tag handling, and customer tier logic — we
  // fetch /products/{handle}?section_id=wishlist-price-renderer for each item.
  // That endpoint renders sections/wishlist-price-renderer.liquid against the
  // current customer session, producing the same HTML as snippets/price.liquid
  // on the PDP. The returned [data-wishlist-rendered-price] element replaces
  // Hulk's price DOM in the wishlist card.
  //
  // Scoped to /apps/advanced-wishlist. Fails gracefully — Hulk price is left
  // unchanged if the fetch fails.

  var shouldRefreshB2BPrices = window.NELLA_WISHLIST_B2B_PRICE_REFRESH === true;
  var priceRefreshTimer = null;
  var priceHtmlCache = {};
  var wishlistDeleteRecleanTimer = null;

  function removePricePreHide() {
    var el = document.getElementById('nella-wishlist-price-prehide');
    if (el && el.parentElement) el.parentElement.removeChild(el);
  }

  function getProductHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var href = (link.getAttribute('href') || '').split('?')[0].split('#')[0];
    var match = href.match(/\/products\/([^/]+)/);
    return match ? match[1] : null;
  }

  function getPriceContainerFromCard(card) {
    // Hulk wraps prices inside .wishlist__product-content. We replace the
    // price region: the .price div plus any sibling compare_price spans and
    // the "Retail Price:" label paragraph above it, all scoped inside content.
    return card.querySelector('.wishlist__product-content') || null;
  }

  function applyRenderedPriceToCard(card, renderedHtml) {
    var content = getPriceContainerFromCard(card);
    if (!content || !content.isConnected) return; // guard: Hulk may have replaced the node after delete
    if (content.hasAttribute('data-nella-price-ready')) return; // idempotency: price already applied (e.g. double-call from reclean + in-flight fetch)

    var parser = new DOMParser();
    var doc = parser.parseFromString(renderedHtml, 'text/html');
    var priceWrapper = doc.querySelector('[data-wishlist-rendered-price]');

    // Only proceed if the wrapper exists and has non-empty content.
    // Never remove Hulk price unless replacement is confirmed present.
    if (!priceWrapper || !priceWrapper.innerHTML.trim()) {
      removePriceSkeleton(content);
      content.removeAttribute('data-nella-price-pending');
      content.removeAttribute('data-nella-price-refreshed');
      content.setAttribute('data-nella-price-fallback', 'true');
      return;
    }

    var hulkPrice = content.querySelector('.hulk-price');
    var imported = document.importNode(priceWrapper, true);
    imported.setAttribute('data-nella-price-rendered', 'true');

    // Find or reuse the existing price slot for this card.
    var slot = content.querySelector('.nella-wishlist-price-slot');

    if (hulkPrice && hulkPrice.parentElement) {
      if (!slot) {
        // Create a slot sized to the original .hulk-price block so the card
        // height does not change when the original is removed.
        slot = document.createElement('div');
        slot.className = 'nella-wishlist-price-slot';
        var originalHeight = hulkPrice.getBoundingClientRect().height;
        if (originalHeight > 0) {
          slot.style.minHeight = Math.ceil(originalHeight) + 'px';
        }
        hulkPrice.parentElement.insertBefore(slot, hulkPrice);
      }
      slot.appendChild(imported);
      // Only remove Hulk price after replacement is inside the slot.
      hulkPrice.parentElement.removeChild(hulkPrice);
      // Clear the explicit min-height now that content fills the slot.
      slot.style.minHeight = '';
    } else {
      // No .hulk-price — reuse existing slot or fall back to appending.
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'nella-wishlist-price-slot';
        content.appendChild(slot);
      }
      slot.appendChild(imported);
    }

    removePriceSkeleton(content);
    content.removeAttribute('data-nella-price-pending');
    content.removeAttribute('data-nella-price-refreshed');
    content.setAttribute('data-nella-price-ready', 'true');
    removePricePreHide();
  }

  function removePriceSkeleton(content) {
    var skeleton = content.querySelector('.nella-wishlist-price-skeleton');
    if (skeleton && skeleton.parentElement) {
      skeleton.parentElement.removeChild(skeleton);
    }
    content.removeAttribute('data-nella-price-skeleton');
  }

  function insertWishlistSkeletons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('.wishlist__product'));
    cards.forEach(function (card) {
      var content = getPriceContainerFromCard(card);
      if (!content) return;
      if (
        content.hasAttribute('data-nella-price-ready') ||
        content.hasAttribute('data-nella-price-fallback') ||
        content.hasAttribute('data-nella-price-skeleton') ||
        content.hasAttribute('data-nella-price-pending')
      ) return;
      var hulkPrice = content.querySelector('.hulk-price');
      if (!hulkPrice || !hulkPrice.parentElement) return;
      var skeleton = document.createElement('span');
      skeleton.className = 'nella-wishlist-price-skeleton';
      skeleton.setAttribute('aria-hidden', 'true');
      hulkPrice.parentElement.insertBefore(skeleton, hulkPrice);
      // Set attribute in the same synchronous task — CSS collapses .hulk-price
      // at the same paint as skeleton insertion so there is no blank state.
      content.setAttribute('data-nella-price-skeleton', '');
    });
  }

  function markCardPending(card) {
    var content = getPriceContainerFromCard(card);
    if (!content) return;
    // Insert skeleton if not already placed by insertWishlistSkeletons.
    if (!content.hasAttribute('data-nella-price-skeleton')) {
      var hulkPrice = content.querySelector('.hulk-price');
      if (hulkPrice && hulkPrice.parentElement) {
        var skeleton = document.createElement('span');
        skeleton.className = 'nella-wishlist-price-skeleton';
        skeleton.setAttribute('aria-hidden', 'true');
        hulkPrice.parentElement.insertBefore(skeleton, hulkPrice);
        content.setAttribute('data-nella-price-skeleton', '');
      }
    }
    content.setAttribute('data-nella-price-pending', '');
    content.setAttribute('data-nella-price-refreshed', 'pending');
  }

  function revealCardFallback(card) {
    var content = getPriceContainerFromCard(card);
    if (!content || !content.isConnected) return; // guard: Hulk may have replaced the node after delete
    removePriceSkeleton(content);
    // Remove empty slot if it was inserted but never filled.
    var slot = content.querySelector('.nella-wishlist-price-slot');
    if (slot && !slot.hasChildNodes()) {
      slot.parentElement && slot.parentElement.removeChild(slot);
    }
    content.removeAttribute('data-nella-price-pending');
    content.removeAttribute('data-nella-price-refreshed');
    content.setAttribute('data-nella-price-fallback', 'true');
    removePricePreHide();
  }

  function refreshWishlistPrices(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('.wishlist__product'));

    if (!cards.length) return;

    var pendingByHandle = {};

    cards.forEach(function (card) {
      var content = getPriceContainerFromCard(card);
      if (!content) return;
      // Skip cards already refreshed, ready, or fallen back.
      var state = content.getAttribute('data-nella-price-refreshed');
      if (state || content.hasAttribute('data-nella-price-ready') || content.hasAttribute('data-nella-price-fallback')) return;

      var handle = getProductHandleFromCard(card);
      if (!handle) return;

      // Mark pending immediately (synchronously) so CSS hides Hulk price now.
      markCardPending(card);

      if (!pendingByHandle[handle]) pendingByHandle[handle] = [];
      pendingByHandle[handle].push(card);
    });

    var handles = Object.keys(pendingByHandle);
    if (!handles.length) return;

    handles.forEach(function (handle) {
      var cardsForHandle = pendingByHandle[handle];

      if (priceHtmlCache[handle]) {
        cardsForHandle.forEach(function (card) {
          applyRenderedPriceToCard(card, priceHtmlCache[handle]);
        });
        return;
      }

      fetch('/products/' + handle + '?section_id=wishlist-price-renderer', {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) {
            cardsForHandle.forEach(revealCardFallback);
            return;
          }
          priceHtmlCache[handle] = html;
          cardsForHandle.forEach(function (card) {
            applyRenderedPriceToCard(card, html);
          });
        })
        .catch(function () {
          cardsForHandle.forEach(revealCardFallback);
        });
    });
  }

  function scheduleWishlistPriceRefresh() {
    if (!shouldRefreshB2BPrices) {
      document.documentElement.classList.add('nella-wishlist-show-original-prices');
      removePricePreHide();
      return;
    }
    // Insert skeletons immediately — no timer — so the prehide blank never shows.
    // The fetch is still deferred by 300ms to let Hulk's rendering stabilize.
    insertWishlistSkeletons(getWishlistAppRoot() || document);
    if (priceRefreshTimer) clearTimeout(priceRefreshTimer);
    priceRefreshTimer = setTimeout(function () {
      priceRefreshTimer = null;
      refreshWishlistPrices(getWishlistAppRoot() || document);
    }, 300);
  }

  // Pass 251/251B: after a card delete (or any Hulk list rebuild), reset any
  // connected card stuck in pending/skeleton state from a stale fetch cycle,
  // then run refreshWishlistPrices unconditionally.
  //
  // Why unconditional: if the reclean fires while Hulk is still building the
  // DOM, stuck-pending cards may not exist yet, so needsRefresh would be false
  // and a conditional call would silently skip freshly-rendered no-state cards.
  // refreshWishlistPrices is safe to call unconditionally — it returns early
  // when all cards are already resolved (handles.length === 0).
  function cleanStalePricePendingCards() {
    if (!shouldRefreshB2BPrices) return;
    var scope = getWishlistAppRoot() || document;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('.wishlist__product'));
    // Reset any connected card whose price state is stuck (set on an old node
    // that was detached by Hulk mid-fetch; the isConnected guard on
    // applyRenderedPriceToCard prevented the write from completing on the new
    // node, leaving state attributes on the now-detached old node — the new
    // connected card inherits no state and needs to be re-queued).
    cards.forEach(function (card) {
      var content = getPriceContainerFromCard(card);
      if (!content || !content.isConnected) return;
      var isStuck = !content.hasAttribute('data-nella-price-ready')
        && !content.hasAttribute('data-nella-price-fallback')
        && (content.hasAttribute('data-nella-price-pending')
            || content.getAttribute('data-nella-price-refreshed') === 'pending'
            || content.hasAttribute('data-nella-price-skeleton'));
      if (!isStuck) return;
      removePriceSkeleton(content);
      content.removeAttribute('data-nella-price-pending');
      content.removeAttribute('data-nella-price-refreshed');
    });
    // Always call — processes no-state freshly-rendered cards and skips
    // already-resolved ones. Cache hit → synchronous apply. Cache miss →
    // normal fetch path. All guarded by isConnected inside apply/fallback.
    refreshWishlistPrices(scope);
  }

  function schedulePostDeletePriceReclean() {
    if (!shouldRefreshB2BPrices) return;
    if (wishlistDeleteRecleanTimer) clearTimeout(wishlistDeleteRecleanTimer);
    wishlistDeleteRecleanTimer = setTimeout(function () {
      wishlistDeleteRecleanTimer = null;
      cleanStalePricePendingCards();
    }, 1200);
  }

  runWishlistOverrides(getWishlistAppRoot());
  ensureWishlistObserver();

  [120, 400, 1000, 2000].forEach(function (delay) {
    setTimeout(function () {
      scheduleWishlistOverrideSync(getWishlistAppRoot(), 0);
    }, delay);
  });

  // Independent price refresh attempts at known post-render milestones.
  // Guarded by shouldRefreshB2BPrices — non-B2B/logged-out never fetches.
  if (shouldRefreshB2BPrices) {
    [600, 1500, 3000].forEach(function (delay) {
      setTimeout(function () {
        refreshWishlistPrices(getWishlistAppRoot() || document);
      }, delay);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!isMobiloudApp) return;

      var link = event.target && event.target.closest
        ? event.target.closest('a[href]')
        : null;

      if (!link) return;

      var href = (link.getAttribute('href') || '').trim();
      if (!isLegacyWishlistLoginHref(href)) return;

      event.preventDefault();
      window.location.assign(appAwareWishlistLoginUrl);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var stableSignedInShareTrigger = event.target && event.target.closest
        ? event.target.closest('[data-nella-signed-in-share-trigger]')
        : null;

      if (!stableSignedInShareTrigger) return;

      var row = stableSignedInShareTrigger.closest('.fancy_title');
      var sourceLink = row
        ? row.querySelector('.share_sbcrb[data-formultipledisabled] [data-HulkShareWishList], .share_sbcrb[data-forMultipleDisabled] [data-HulkShareWishList], .share_sbcrb[data-formultipledisabled] [data-hulksharewishlist], .share_sbcrb[data-forMultipleDisabled] [data-hulksharewishlist]')
        : null;

      if (!sourceLink) return;

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      sourceLink.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var shareTrigger = event.target && event.target.closest
        ? event.target.closest('[data-HulkShareWishList], [data-hulksharewishlist]')
        : null;

      if (!shareTrigger) return;

      scheduleSignedInShareModalCleanup();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var guestShareTrigger = event.target && event.target.closest
        ? event.target.closest('[data-HulkGuestShareWishList], [data-hulkguestsharewishlist]')
        : null;

      if (!guestShareTrigger) return;

      scheduleGuestShareModalCleanup();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var shareSubmit = event.target && event.target.closest
        ? event.target.closest('[data-HulkSendEmailButton]')
        : null;

      if (!shareSubmit) return;

      pendingShareToastUntil = Date.now() + 5000;
      setTimeout(normalizeWishlistNotifications, 50);
      setTimeout(normalizeWishlistNotifications, 250);
      setTimeout(normalizeWishlistNotifications, 1000);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target && event.target.closest
        ? event.target.closest('[data-hulkemptywishlist] .wishlist-btn.hulkBtnStyle.hulk-btn-styled')
        : null;

      if (!button) return;

      button.setAttribute('href', '/');
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      window.location.assign('/');
    },
    true
  );

  // On bfcache restore, re-run the override sync so all wishlist UI
  // normalizations are reapplied to the restored DOM. scheduleWishlistOverrideSync
  // is used (not runWishlistOverrides directly) because it also calls
  // ensureWishlistObserver(), re-attaching the MutationObserver if the
  // wishlist root changed. Individual normalizers are idempotent so re-running
  // is safe: they check current state before mutating.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (!window.location.pathname.startsWith('/apps/advanced-wishlist')) return;
    scheduleWishlistOverrideSync(getWishlistAppRoot(), 0);
  });

});
